import React from 'react';
import Icon from "./Icon";

const IconHeart = ({active}) => {
    return (
        <Icon image={active ? "/img/icons/icon-heart-red.svg" : "/img/icons/icon-heart.svg"}/>
    )
};

export default IconHeart;